import { ComponentProps, PropsWithChildren } from 'react'

import { JourneyPaneProvider } from './JourneyPaneProvider'

export const JourneyProvider = ({
  children,
  ...props
}: PropsWithChildren<ComponentProps<typeof JourneyPaneProvider>>) => {
  return <JourneyPaneProvider {...props}>{children}</JourneyPaneProvider>
}
